export enum PublicEICStatus
{
    A05 = 0,
    A03 = 1
}